import { apiFuns } from "sw-hic";
let { get, put, del, post, genStandard, exceptedReqs } = apiFuns;
// 允许重复
exceptedReqs.push(/api\/md\/staff\/.*/i);
console.log(exceptedReqs);
const api = {
  /*********** 住院记录 ***********/
  Hospitalization: {
    ...genStandard("hospitalization", "/api/ip", false),
    getByNo: (no) => get(`/api/ip/hospitalization/ipNo/${no}`),
    checkIn: (id, para) => put(`/api/ip/hospitalization/${id}/checkin`, para), // 入科
    cancelCheckIn: (id) => del(`/api/ip/hospitalization/${id}/checkin`), // 取消入科
    cancelCheckOut: (id) => del(`/api/ip/hospitalization/${id}/checkout`), // 取消出科
    cancelOut: (id) => del(`/api/ip/hospitalization/${id}/out`), // 取消离院
  },
  /*********** 医嘱 ***********/
  Advice: genStandard("advice", "/api/ip"),
  /*********** 床位 ***********/
  Bed: {
    ...genStandard("bed", "/api/ip"),
    wrap: (id, hospId) => post(`/api/ip/bed/${id}/wrap/${hospId}`),
    cancel: (id) => del(`/api/ip/bed/${id}/wrap`),
    primary: (id) => put(`/api/ip/bed/${id}/primary`),
    exchange: (id, tgtId) => put(`/api/ip/bed/${id}/exchange/${tgtId}`),
    fee: (id) => get(`/api/ip/bed/${id}/feeStandard`),
  },
  BedLog: genStandard("bedLog", "/api/ip"),
  /*********** 床位费用 ***********/
  BedFee: genStandard("bedFee", "/api/ip"),
  BedTypeFee: genStandard("bedTypeFee", "/api/ip", false),
  FeeStandard: genStandard("feeStandard", "/api/md", false),
  AdviceLog: genStandard("adviceLog", "/api/ip"),

  /*********** 记账记录 ***********/
  Billing: {
    ...genStandard("billing", "/api/ip"),
    sum: (para) => apiFuns.get(`/api/ip/billing/sum`, para),
  },

  /*********** 标准费用 ***********/
  FeeStandard: genStandard("feeStandard", "/api/md"),
  MlItem: genStandard("item", "/api/ml"),
  Patient: genStandard("patient", "/api/patient"),
};

export default api;
